import BookingService from "../services/BookingService";

let bookingService = new BookingService(localStorage.getItem('user'));

export const ReservationDocument = {
	YOUR_BOOKING: {
		name: 'Your Booking',
		generate: bookingService.getYourBookingPdf
	},
	INVOICE: {
		name: 'Invoice',
		generate: bookingService.getInvoicePdf
	},
	HOTEL_VOUCHER: {
		name: 'Voucher de Hotel',
		generate: bookingService.getVoucherPdf
	}
}



// WEBPACK FOOTER //
// ./src/enums/ReservationDocument.js